export default "__VITE_ASSET__D4NcmCq5__"